import { render, staticRenderFns } from "./partnerReports.vue?vue&type=template&id=16f53b1e&scoped=true&"
import script from "./partnerReports.vue?vue&type=script&lang=js&"
export * from "./partnerReports.vue?vue&type=script&lang=js&"
import style0 from "./partnerReports.vue?vue&type=style&index=0&id=16f53b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f53b1e",
  null
  
)

export default component.exports